import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as ORDERING_PROVIDER[] | null;

const slice = createSlice({
  name: '$thresholdOrderingProviders',
  initialState,
  reducers: {
    setThresholdOrderingProviders(
      state,
      action: PayloadAction<ORDERING_PROVIDER[] | null>,
    ) {
      return action.payload;
    },
  },
});

export const { setThresholdOrderingProviders } = slice.actions;
export default slice.reducer;
